import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  PinInput,
  PinInputField,
  HStack,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeLoginStatus } from "../../Redux/action";
import { SigninAuthentication } from "./LoginAuthentication";
import { Register_DB } from "../../api";

const OTPform = () => {
  // const isLoggedIn = useSelector((state) => state.isLoggedIn);
  // const userDetails = useSelector((state) => state.userDetails);
  const [registerd , setRegisterd] = useState(false);
  const [succesful , setsuccesful] = useState(true);    
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const init = {
    goodEmail: true,
    goodgst: true,
    goodfirm: true,
    goodnumber: true,
    goodpassword : true,
    gooddl : true,
    //goodOTP: true,
    //validOTP: true,
  };
  const [validations, setValidations] = useState({
    ...init,
  });
  //const [otp, setOTP] = useState();
  //const [generatedOTP, setGeneratedOTP] = useState();
  const [loadingSignup, setLoadingSignup] = useState(false);
  const Email = useRef();
  const GST = useRef();
  const Firm = useRef();
  const Number = useRef();
  const City = useRef();
  const DL = useRef(); 
  const Password = useRef();
  const goodEmailCheck = (entryEmail) => {
    const regexExp =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi;

    return regexExp.test(entryEmail);
  };
  
  const onSetRegisrerd = () =>{
    setRegisterd(!registerd);
  }
  const onSetSuccesful = () =>{
    setsuccesful(!succesful);
  }

  const handleValidations = (event) => {
    event.preventDefault();
    const formEntries = {
      email: Email.current.value,
      gst: GST.current.value,
      firm: Firm.current.value,
      number: Number.current.value,
      city : City.current.value,
      dl : DL.current.value,
      password : Password.current.value
    };

    if (!goodEmailCheck(formEntries.email)) {
      setValidations({ ...init, goodEmail: false });
      return;
    } else if (formEntries.gst.length === 0){
      setValidations({ ...init, goodgst: false });
      return;
    } else if (formEntries.firm.length === 0) {
      setValidations({ ...init, goodfirm: false });
      return;
    } else if(Number.current.value.length !== 10){
      setValidations({ ...init, goodnumber: false });
      return;
    }
    Authenticate(formEntries);
  };
  const Authenticate = (result) => {
    setLoadingSignup(true);
    fetch(Register_DB,{
        method : "post",
        headers : {"Content-Type": 'application/json'},
        body : JSON.stringify(result)
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        }
        return Promise.reject(response);;
      })
      .then(data => {
        if(data == "Done"){
          onSetRegisrerd()
        }
      })
      .catch((response) => {
        console.log(response.status, response.statusText);
        response.json().then((json) => {
          console.log(json);
        onSetSuccesful();
      })})
      .finally(() => {
        onSetRegisrerd();
        setLoadingSignup(false);
      });
  };

  return (
    <Box width={"468px"} padding="30px 48px" height="730px">
    { (registerd)  
    ? <>
        {(succesful) 
          ? <Box> You have Succesfully Registered. You will Receive a Mail within 48 Hours with your Credentials. PLease Sit Back and Relax. For any queries or error Kindly <a href="mailto:queries.udyog@gmail.com" color="Red" _hover="blue">Email Us</a>.</Box> 
          : <Box> Registation NOT done. There is Some error while registering. Please try again</Box>
        }
      </>
    : <>
        <Text fontSize={"24px"} fontWeight="bold" mb={"15px"}>
          Create Account
        </Text>
        <form onSubmit={handleValidations}>
          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              EMAIL ID
            </Text>
            <Input
              ref={Email}
              variant="flushed"
              height="24px"
              placeholder="Enter your Email Id"
              fontSize={"16px"}
            />
            {
              <Text color={"red"} fontSize="11px" hidden={validations.goodEmail}>
                Please enter a valid email!
              </Text>
            }
          </Box>
          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              GST number
            </Text>
            <Input
              ref={GST}
              variant="flushed"
              height="24px"
              placeholder="Enter your GST Number"
              fontSize={"16px"}
            />
            {
              <Text
                color={"red"}
                fontSize="11px"
                hidden={validations.goodgst}
              >
                Please enter GST number properly
              </Text>
            }
          </Box>
          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              Firm name
            </Text>
            <Input
              ref={Firm}
              variant="flushed"
              height="24px"
              placeholder="Enter your Firm Name"
              fontSize={"16px"}
            />
            {
              <Text
                color={"red"}
                fontSize="11px"
                hidden={validations.goodfirm}
              >
                Please enter your Firm Name
              </Text>
            }
          </Box>

          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              Contact Number
            </Text>
            <Input
              ref={Number}
              variant="flushed"
              height="24px"
              placeholder="Enter your Contact number"
              fontSize={"16px"}
            />
            {
              <Text
                color={"red"}
                fontSize="11px"
                hidden={validations.goodnumber}
              >
                Please enter mobile number correctly
              </Text>
            }
          </Box>

          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              Full Address
            </Text>
            <Input
              ref={City}
              variant="flushed"
              height="24px"
              placeholder="Enter your City"
              fontSize={"16px"}
            />
          </Box>

          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              Drug License Number
            </Text>
            <Input
              ref={DL}
              variant="flushed"
              height="24px"
              placeholder="Enter your Drug License Number"
              fontSize={"16px"}
            />
            {
              <Text
                color={"red"}
                fontSize="11px"
                hidden={validations.gooddl}
              >
                Please enter  Drug License Number correctly
              </Text>
            }
          </Box>

          <Box mb={"38px"}>
            <Text fontSize={"13px"} color="#5e17eb">
              Password
            </Text>
            <Input
              ref={Password}
              variant="flushed"
              height="24px"
              placeholder="Enter your Password"
              fontSize={"16px"}
              type="password"
            />
            {
              <Text
                color={"red"}
                fontSize="11px"
                hidden={validations.goodpassword}
              >
                Please enter Password correctly
              </Text>
            }
          </Box>

          <Button
            type="submit"
            isLoading={loadingSignup}
            mt="24px"
            bg={"#5e17eb"}
            color="white"
            fontSize="14px"
            paddingBlock={"10px"}
            height="41px"
            width={"100%"}
            _hover={{ background: "green" }}
          >
            VERIFY
          </Button>
        </form>
        </>
      }
      </Box>
  );
};
export default OTPform;
